import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker as MuiKeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { withStyles } from '@material-ui/core';
import KailonaTextField from '../TextField/KailonaTextField';
var KeyboardDateTimePicker = withStyles({
  root: {
    '& input': {
      border: 'none !important'
    }
  }
})(MuiKeyboardDateTimePicker);
var DATE_TIME_FORMAT = 'MMM d, yyyy, HH:mm';

var KailonaDateTimePicker = /*#__PURE__*/function (_Component) {
  _inherits(KailonaDateTimePicker, _Component);

  var _super = _createSuper(KailonaDateTimePicker);

  function KailonaDateTimePicker(props) {
    var _this;

    _classCallCheck(this, KailonaDateTimePicker);

    _this = _super.call(this, props);
    _this.state = {
      dateTimeFormat: _this.props.dateTimeFormat || DATE_TIME_FORMAT
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(KailonaDateTimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.defaultValue) {
        this.setState({
          date: this.props.defaultValue
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(date) {
      this.setState({
        date: date
      });

      if (this.props.onChange && typeof this.props.onChange === 'function') {
        this.props.onChange(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
        utils: DateFnsUtils
      }, /*#__PURE__*/React.createElement(KeyboardDateTimePicker, {
        variant: "inline",
        format: this.state.dateTimeFormat,
        id: this.props.id,
        value: this.state.date,
        placeholder: t('ehr', 'Select Date/Time'),
        onChange: this.handleChange,
        KeyboardButtonProps: {
          'aria-label': this.props.ariaLabel
        },
        TextFieldComponent: function TextFieldComponent(props) {
          return /*#__PURE__*/React.createElement(KailonaTextField, _extends({}, props, {
            inputRef: _this2.props.inputRef
          }));
        },
        autoOk: true,
        disableFuture: this.props.disableFuture
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaDateTimePicker;
}(Component);

export { KailonaDateTimePicker as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(KeyboardDateTimePicker, "KeyboardDateTimePicker", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateTimePicker.js");
  reactHotLoader.register(DATE_TIME_FORMAT, "DATE_TIME_FORMAT", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateTimePicker.js");
  reactHotLoader.register(KailonaDateTimePicker, "KailonaDateTimePicker", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateTimePicker.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();